import CouponModal from './CouponModal';

export default (props) => <CouponModal {...props} />;
